module.exports = __webpack_public_path__ + "static/media/notification.9aff81e6.svg";